export default "__VITE_ASSET__Dl3mielj__"